import React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';

interface IZammadDeactivationModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    label?: string;
}

// Mirrors IntegrationSettings.tsx's own pendingDisableKey Dialog markup/props shape rather than
// Sherloq's bespoke SherloqDeactivationModal, per this codebase's existing confirmation-dialog pattern.
export const ZammadDeactivationModal: React.FC<IZammadDeactivationModalProps> = ({
    isOpen,
    onCancel,
    onConfirm,
    label = IvicosStrings.zammadSettingsToggleLabel
}) => {
    return (
        <Dialog
            hidden={!isOpen}
            onDismiss={onCancel}
            dialogContentProps={{
                type: DialogType.normal,
                title: IvicosStrings.disableProviderDialogTitle.replace('{0}', label),
                subText: IvicosStrings.disableProviderDialogWarning.replace('{0}', label)
            }}
            modalProps={{ isBlocking: true, styles: { main: { maxWidth: '90vw', minWidth: 'min(320px, 90vw)' } } }}
        >
            <DialogFooter>
                <DefaultButton text={IvicosStrings.disableProviderDialogCancel} onClick={onCancel} />
                <DefaultButton
                    text={IvicosStrings.disableProviderDialogConfirm}
                    onClick={onConfirm}
                    styles={{
                        root: { backgroundColor: 'red', borderColor: 'red', color: 'white' },
                        rootHovered: { backgroundColor: '#cc0000', borderColor: '#cc0000', color: 'white' }
                    }}
                />
            </DialogFooter>
        </Dialog>
    );
};
